import { useEffect } from 'react';

import { Pages } from '../../components/Pages/Pages';
import { ApplicationState } from '../../domain/types';
import { useAppDispatch } from '../../hooks';
import useApplicationStateRefresh from '../../hooks/useApplicationStateRefresh';
import { useAuthentication } from '../../hooks/useAuthentication';
import useSettings from '../../hooks/useSettings';
import AccountInfoPage from '../../pages/AccountInfoPage/AccountInfoPageNO';
import ConsolidationComplementInfoPage from '../../pages/ConsolidationComplementInfoPage/ConsolidationComplementInfoPage';
import DocumentUploadComplementInfoPage from '../../pages/DocumentUploadComplementInfoPage/DocumentUploadComplementInfoPage';
import CoApplicantEmploymentPage from '../../pages/EmploymentPage/CoApplicantEmploymentPageNO';
import ErrorPage from '../../pages/ErrorPage/ErrorPage';
import CoApplicantExpensePage from '../../pages/ExpensePage/CoApplicantExpensePage';
import CoApplicantHowToApplyPage from '../../pages/HowToApplyPage/CoApplicantHowToApplyPage';
import CoApplicantIncomePage from '../../pages/IncomePage/CoApplicantIncomePage';
import CoApplicantKycOngoingPage from '../../pages/KycPage/CoApplicantKycOngoingPage';
import CoApplicantKycPage from '../../pages/KycPage/CoApplicantKycPage';
import KycPage from '../../pages/KycPage/KycPage';
import CoApplicantLivingConditionPage from '../../pages/LivingConditionPage/CoApplicantLivingConditionPage';
import PpiAutoDecline from '../../pages/PpiPage/PpiAutoDecline';
import PpiPage from '../../pages/PpiPage/PpiPageNO';
import SelectOfferPage from '../../pages/SelectOfferPage/SelectOfferPage';
import SignAgreementPage from '../../pages/SignAgreementPage/SignAgreementPage';
import OngoingStaticPage from '../../pages/StatusPage/OngoingStaticPage';
import CoApplicantSubmitPage from '../../pages/SubmitPage/CoApplicantSubmitPage';
import { setCurrentPage } from '../../store/wizard/wizard';

const OngoingApplicationWizardNO = () => {
    const dispatch = useAppDispatch();
    useAuthentication();
    const { isError, applicationState } = useApplicationStateRefresh();
    const { showPpiPage } = useSettings();

    useEffect(() => {
        dispatch(setCurrentPage(0));
    }, [dispatch]);

    if (isError) {
        return <ErrorPage />;
    }

    const getPage = () => {
        switch (applicationState) {
            case 'CO_SUBMIT':
                return (
                    <Pages>
                        <CoApplicantHowToApplyPage />
                        <CoApplicantLivingConditionPage />
                        <CoApplicantEmploymentPage />
                        <CoApplicantIncomePage />
                        <CoApplicantExpensePage />
                        <CoApplicantKycPage />
                        <CoApplicantSubmitPage />
                    </Pages>
                );
            case 'ACCEPT_OFFER_MAIN_APPLICANT':
                return (
                    <Pages>
                        <SelectOfferPage />
                    </Pages>
                );
            case 'DISBURSEMENT_ACCOUNT_INFORMATION_MAIN_APPLICANT':
                return (
                    <Pages>
                        <AccountInfoPage />
                    </Pages>
                );
            case 'PPI_MAIN_APPLICANT':
                if (!showPpiPage) {
                    return <PpiAutoDecline />;
                }
                return (
                    <Pages>
                        <PpiPage />
                    </Pages>
                );
            case 'COMPLEMENT_INFORMATION_CONSOLIDATIONS':
                return (
                    <Pages>
                        <ConsolidationComplementInfoPage />
                    </Pages>
                );
            case 'COMPLEMENT_INFORMATION_MAIN_APPLICANT':
                return (
                    <Pages>
                        <DocumentUploadComplementInfoPage />
                    </Pages>
                );
            case 'KYC_MAIN_APPLICANT':
                return (
                    <Pages>
                        <KycPage />
                    </Pages>
                );
            case 'KYC_CO_APPLICANT':
                return (
                    <Pages>
                        <CoApplicantKycOngoingPage />
                    </Pages>
                );
            case 'SIGN_AGREEMENT':
                return (
                    <Pages>
                        <SignAgreementPage />
                    </Pages>
                );
            default:
                return <OngoingStaticPage applicationState={applicationState as ApplicationState} />;
        }
    };

    return <>{getPage()}</>;
};

export default OngoingApplicationWizardNO;
